const UI_PREFERENCE_KEY = "cirrom-preferred-ui";

type UIPreference = "product" | "app";

const VALID_PREFERENCES: UIPreference[] = ["product", "app"];
const DEFAULT_PREFERENCE: UIPreference = "app";

export function getPreferredUI(): UIPreference {
  const stored = localStorage.getItem(UI_PREFERENCE_KEY);
  if (stored && VALID_PREFERENCES.includes(stored as UIPreference)) {
    return stored as UIPreference;
  }
  if (stored !== null) {
    localStorage.removeItem(UI_PREFERENCE_KEY);
  }
  return DEFAULT_PREFERENCE;
}

export function setPreferredUI(preference: UIPreference): void {
  localStorage.setItem(UI_PREFERENCE_KEY, preference);
}

export function getPreferredDashboardPath(): string {
  return getPreferredUI() === "product"
    ? "/product/dashboard"
    : "/app/dashboard";
}
